// extracted by mini-css-extract-plugin
export var container = "Tooltip-module--container--d68fa";
export var icon = "Tooltip-module--icon--70172";
export var mechanic = "Tooltip-module--mechanic--e76ca";
export var mechanics = "Tooltip-module--mechanics--bcaa0";